module.exports = __webpack_public_path__ + "img/index_yewu_icon_jiaot.98cd8fe0.png";